import type {
  RestoreBlocksHiddenFromPreview,
  SummaryBlockCreate,
  SummaryBlockDelete,
  SummaryBlockHideFromPreview,
  SummaryBlockReorder,
  SummaryBlockShowInPreview,
  SummaryBlockUpdate,
  SummarySectionDelete,
  SummarySectionReorder,
} from '@domain/schemas/endorsement-summary.schema';
import { getCurrentDocumentApiUrl } from '@helpers/getCurrentDocumentApiUrl';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { ContractPatchResponse } from '@responses/common';
import axios from 'axios';

import { queryClient } from '../utils/queryClient';

type PatchEndorsementSummaryData =
  | SummaryBlockCreate
  | SummaryBlockDelete
  | SummaryBlockHideFromPreview
  | SummaryBlockShowInPreview
  | SummaryBlockReorder
  | SummaryBlockUpdate
  | RestoreBlocksHiddenFromPreview
  | SummarySectionDelete
  | SummarySectionReorder;

export const patchEndorsementSummary = async <Op extends PatchEndorsementSummaryData['operation']>(
  data: PatchEndorsementSummaryData & { operation: Op },
): Promise<ContractPatchResponse<Op>> => {
  const url = getCurrentDocumentApiUrl(location.pathname);
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url,
    data,
  });

  const response = await axios(networkPayload);
  await queryClient.invalidateQueries({ queryKey: ['submissions'] });
  await queryClient.invalidateQueries({ queryKey: ['search'] });
  return response.data;
};
